import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة تبسيط الكسور";
const DESCRIPTION =
  "حاسبة الكسور المتقدمة: بسّط أي كسر إلى أبسط صورة، حوّله إلى كسر مختلط أو عدد عشري بدقة! أدخل البسط والمقام لتحصل على النتائج مع شرح خطوات الحل - أداة ضرورية لطلاب الرياضيات والمعلمين.";
const KEYWORDS = "تبسيط, كسور, رياضيات, حاسبة, عدد كسري";
const OG_URL = "https://do-calculate.com/calculator/ar/simplify-fractions/";
function FractionsCalculator() {
  const [numerator, setNumerator] = useState(5);
  const [denominator, setDenominator] = useState(1);
  const [result, setResult] = useState("");
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    setError("");
    setSteps([]);
    const num = parseInt(numerator);
    const denom = parseInt(denominator);
    if (denom === 0) {
      setError("خطأ: لا يمكن القسمة على الصفر.");
      return;
    }
    const wholePart = Math.floor(num / denom);
    const remainder = num % denom;
    const calculationSteps = [
      `${num} ÷ ${denom} = ${wholePart} والباقي ${remainder}`,
    ];
    let resultText = ``;
    if (remainder === 0) {
      resultText =
        `\u0020${num}\n` +
        `\u2014 = ${wholePart}\n` +
        `\u0020${denom}`;
      calculationSteps.push(
        `البسط يقسم تمامًا على المقام، لذلك النتيجة هي ${wholePart}.`
      );
    } else {
      resultText =
        `\u0020${num}\u0020\u0020\u0020\u0020\u0020\u0020\u0020    ${remainder}\n` +
        `\u2014 = ${wholePart}    \u2014\n` +
        `\u0020${denom}\u0020\u0020\u0020\u0020\u0020\u0020\u0020\u0020    ${denom}`;
      calculationSteps.push(
        `لأن الباقي هو ${remainder}، النتيجة النهائية هي \n \u0020${remainder}\n \u2014\u0020${wholePart}\u0020\n${denom}.`
      );
    }
    setResult(resultText);
    setSteps(calculationSteps);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة تبسيط الكسور: أداة مجانية وسهلة الاستخدام لتحويل الكسور
                  إلى كسور مختلطة أو عدد كسري. مثالية لحل مسائل الكسور في
                  الرياضيات والعلوم، تساعدك الحاسبة على توفير الوقت والجهد
                  والحصول على نتائج دقيقة في ثوانٍ معدودة. استخدمها بسهولة
                  وسرعة، مثالية للطلاب والمعلمين والمهندسين وغيرهم ممن يتعاملون
                  مع الكسور بشكل يومي.
                </p>
                <hr />
              </div>
              <br />
            </div>
                <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="d-flex justify-content-center align-items-center">
                      <div>
                        <input
                          type="number"
                          value={numerator}
                          onChange={(e) => setNumerator(e.target.value)}
                          placeholder="البسط"
                          className="form-control"
                          style={{ width: "80px", textAlign: "center" }}
                        />
                        <hr />
                        <input
                          type="number"
                          value={denominator}
                          onChange={(e) => setDenominator(e.target.value)}
                          placeholder="المقام"
                          className="form-control"
                          style={{ width: "80px", textAlign: "center" }}
                        />
                      </div>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error && (
                    <p className="p-3 mb-2 bg-warning text-black">{error}</p>
                  )}
                  { result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p style={{ whiteSpace: "pre-wrap" }}>{result}</p>
                      <h5>الخطوات:</h5>
                      {steps.map((step, index) => (
                        <p key={index} style={{ whiteSpace: "pre-line" }}>
                          {step}
                        </p>
                      ))}
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">معلومات إضافية</div>
              <div className="info-section-body">
                <b>
                  <u>ما هي حاسبة تبسيط الكسور؟</u>
                </b>
                <p>
                  حاسبة تبسيط الكسور هي أداة تساعدك على تحويل الكسور إلى كسور
                  مختلطة أو أعداد كسرية. تقوم الحاسبة بإظهار الناتج بخطوات مفصلة
                  لسهولة الفهم.
                </p>
                <b>
                  <u>كيفية استخدام الحاسبة</u>
                </b>
                <p>
                  لاستخدام الحاسبة، قم بإدخال البسط والمقام للكسر الذي تريد
                  تبسيطه، ثم انقر على زر "احسب" للحصول على النتيجة المبسطة.
                </p>
                <b>
                  <u>شرح النتائج</u>
                </b>
                <p>
                  ستعرض الحاسبة النتيجة النهائية كعدد كسري أو كسر مختلط مع شرح
                  الخطوات التي تم اتباعها للوصول إلى هذه النتيجة.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FractionsCalculator;
